import { FetchContext } from '../fetch-context';
import { responseErrorHandler } from '../response-error-handler';

export const deleteEventAttendee: (
  fetchContext: FetchContext,
  eventAttendeeId: number,
  accessToken?: string) => Promise<void> = (fetchContext, eventAttendeeId, accessToken) => 
    fetch(`${fetchContext.baseUrl}/api/event-attendees/${eventAttendeeId}`, {
    method: 'DELETE',
    headers: {
      Authorization: `Bearer ${accessToken}`,
      'Content-Type': 'application/json',
    },
  }).then((response) => responseErrorHandler<void>(fetchContext.errorStore, response, 'delete event attendee'));
